import { Share } from '@capacitor/share';
import { Capacitor } from '@capacitor/core';
import { toast } from 'sonner';

const APP_URL = import.meta.env.VITE_APP_URL || window.location.origin;

interface ShareDishParams {
  name: string;
  slug?: string | null;
  id: string;
  restaurant?: string | null;
  campaign?: string;
}

export async function shareDish({ name, slug, id, restaurant, campaign = 'dish_share' }: ShareDishParams): Promise<void> {
  const dishIdentifier = slug || id;
  const shareUrl = `${APP_URL}/dish/${dishIdentifier}?utm_source=share&utm_medium=native&utm_campaign=${campaign}`;
  const text = restaurant ? `Check out ${name} at ${restaurant}!` : `Check out ${name}!`;

  try {
    if (Capacitor.isNativePlatform()) {
      await Share.share({
        title: name,
        text,
        url: shareUrl,
        dialogTitle: 'Share with friends',
      });
    } else if (navigator.share) {
      await navigator.share({ title: name, text, url: shareUrl });
    } else {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copied!');
    }
  } catch (error) {
    const msg = (error as Error).message || '';
    const errName = (error as Error).name || '';
    // Ignore user-cancelled shares
    if (errName === 'AbortError' || msg.toLowerCase().includes('cancel')) return;
    await navigator.clipboard.writeText(shareUrl);
    toast.success('Link copied!');
  }
}
